import { render, staticRenderFns } from "./JobPreviewRequirements.vue?vue&type=template&id=6d581130&scoped=true"
import script from "./JobPreviewRequirements.vue?vue&type=script&lang=js"
export * from "./JobPreviewRequirements.vue?vue&type=script&lang=js"
import style0 from "./JobPreviewRequirements.vue?vue&type=style&index=0&id=6d581130&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d581130",
  null
  
)

export default component.exports